'use client';

import {getBaseUrl} from '@website/lib/services/utils';
import {languages} from '@website/constants';
import {useLocale, useTranslations} from 'next-intl';
import {useState} from 'react';

type Goal = 'mentalHealth' | 'weightLoss';

export const ChooseCare = () => {
  const locale = useLocale();
  const t = useTranslations('ChooseCare');
  const [selected, setSelected] = useState<Goal>('mentalHealth');

  const countryCode = locale?.split('-')[1];
  const country = languages.find(
    lang => lang.countryCode.toLowerCase() === countryCode?.toLowerCase(),
  );
  const countryParam = country?.country ?? 'United States';

  const buildProviderUrl = (
    profession: string,
    conditions: string,
    servicesOffered: string,
  ) => {
    const base = `${getBaseUrl()}/${locale}/direct-booking/providers`;
    const params = new URLSearchParams({
      profession,
      state: '',
      conditions,
      servicesOffered,
      paymentType: '',
      country: countryParam,
    });
    return `${base}?${params.toString()}`;
  };

  const urls: Record<Goal, string> = {
    mentalHealth: buildProviderUrl('', '', ''),
    weightLoss: buildProviderUrl('Prescriber', '', 'weight-loss'),
  };

  const options: {value: Goal; label: string}[] = [
    {value: 'mentalHealth', label: t('mentalHealthTitle')},
    {value: 'weightLoss', label: t('weightLossTitle')},
  ];

  const handleContinue = () => {
    window.location.href = urls[selected];
  };

  return (
    <div className="min-h-[calc(100vh-160px)] flex flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-sm">
        <h1 className="text-4xl font-semibold font-montserrat mb-8">
          {t('title')}
        </h1>

        <div className="flex flex-col gap-3 mb-6">
          {options.map(option => (
            <button
              key={option.value}
              onClick={() => setSelected(option.value)}
              className={`flex items-center justify-between w-full px-5 py-4 rounded-xl border text-left font-inter transition-all duration-150 ${
                selected === option.value
                  ? 'border-black bg-white font-medium'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-400'
              }`}
            >
              <span>{option.label}</span>
              <span
                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
                  selected === option.value ? 'border-black' : 'border-gray-300'
                }`}
              >
                {selected === option.value && (
                  <span className="w-2.5 h-2.5 rounded-full bg-black" />
                )}
              </span>
            </button>
          ))}
        </div>

        <button
          onClick={handleContinue}
          className="w-full bg-black text-white py-4 rounded-full font-medium flex items-center justify-center gap-2 hover:bg-gray-900 transition-colors duration-200"
        >
          {t('getStarted')} →
        </button>
      </div>
    </div>
  );
};
